import {ip_back , api_key} from '../constants/appConstants';

const API_URL = ip_back + '/api/tipos_docs';

export const cargarTiposDocumentos = async (categoria) => {
    try {
        const token = JSON.parse(localStorage.getItem("token"));
        const params = new URLSearchParams({
          "categoria": categoria
        });
      const response = await fetch(`${API_URL}/listar?${params}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
      return response.json();
    } catch (error) {
        console.error('Error al hacer la solicitud:', error);
        return [];
    }
};

export const crearTipoDocumento = async (formData, creador) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/crear`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ "tipo" : formData.tipo, "categoria" : formData.categoria, "unico" : formData.unico ? "1" : "0", "creador" : creador}),
      });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const eliminarTipoDocumento = async (id, editor) => { 
  try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(`${API_URL}/eliminar`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': api_key,
          Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ "id" : id, "editor" : editor}),
        });
          return response;
      } catch (error) {
        console.error('Error al hacer la solicitud:', error);
      }
};